export const ROOT = `/adtraction/v1`;
